export function getDefaultTerminationDate() {
	let today = new Date();
	return today;
}

export function getDefaultTerminationTime() {
	return 'ASAP';
}
